import { api } from "..";

import { QueryProps } from "@/types/Api";
import { RiskMatchesResult } from "@/types/ApiResponses/Risk";

export interface GetRiskMatchesParams {
  limit?: number;
}

export const getRiskMatches = async (
  props: QueryProps<GetRiskMatchesParams>
): Promise<RiskMatchesResult> => {
  const res = await api.client.get("/risk/matches", {
    signal: props.signal,
    params: props.params
  });
  return res.data;
};
